import React from "react";
import { Chart } from "react-google-charts";
const divStyle = {
  minWidth: "100%",
  color: "white",
};

class Stats extends React.Component {
  render() {
    return (
      <>
        <div style={divStyle}>
          <Chart
            width={"100%"}
            height={"80vh"}
            chartType="AreaChart"
            loader={<div>Loading Chart</div>}
            data={[
              ["Luna", "interactiuni"],
              ["Ianuarie", 4],
              ["Februarie", 9],
              ["Martie", 15],
              ["Aprilie", 23],
              ["Mai", 68],
              ["Iunie", 76],
              ["Iulie", 128],
              ["August", 56],
              ["Septembrie", 40],
              ["Octombrie", 16],
              ["Noiembrie", 6],
              ["Decembrie", 10],
            ]}
            options={{
              title: "Numar Interactiuni",
              hAxis: {
                title: "Luna, 2020",
                titleTextStyle: { color: "black" },
              },
              vAxis: { minValue: 0 },
              // For the legend to fit, we make the chart area smaller
              chartArea: { width: "70%", height: "70%" },
              // lineWidth: 25
            }}
          />
        </div>
      </>
    );
  }
}
export default Stats;
